import { Injectable } from "@angular/core";
import * as THREE from '@phdsoft/three';
import { VertexNormalsHelper } from 'three/examples/jsm/helpers/VertexNormalsHelper.js';
import { PhdsoftCommonService, StorageService, Util } from "@phdsoft/common";
import { AssetManager } from "src/app/asset-manager/asset-manager";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import { MaHGLTFLoader } from "../Three/MaHGLTFLoader";
import { WorkableElement } from "src/app/platform/busines-data/SectionElements/WorkableElement";
import { InspectionCampaign } from "src/app/platform/busines-data/Campaigns/InspectionCampaign";
import { ElementResultInfo } from "projects/phdsoft/common/src/lib/models/element-result-info.model";
import { v4 as uuid } from 'uuid'
import { AssetManagerInspection } from "src/app/asset-manager/asset-manager-inspection";
import { Graphics } from "../graphics/graphics";

@Injectable({ providedIn: 'root' })
export class DroneImage {

    private manager: THREE.LoadingManager;
    private gltfLoader: MaHGLTFLoader;
    private dracoLoader: DRACOLoader;

    private droneGeometry: THREE.Group;
    private pointsGeometry: THREE.Group;
    private material: THREE.PointsMaterial;
    public constructor(
        private phdsoftCommonService: PhdsoftCommonService,
        private graphics: Graphics,
        private storageService: StorageService,
        private assetManager: AssetManager,
        private assetManagerInspection: AssetManagerInspection
    ) {
        if (Util.isNullOrUndefined(this.gltfLoader)) {
            this.gltfLoader = new MaHGLTFLoader(this.manager);
        }

        if (Util.isNullOrUndefined(this.dracoLoader)) {

            this.dracoLoader = new DRACOLoader(this.manager);
            this.dracoLoader.setDecoderPath('/statics/draco/');
            // this.dracoLoader.setDecoderConfig({ type: 'js' });
            this.dracoLoader.setWorkerLimit(6);
            this.dracoLoader.preload();

            this.gltfLoader = this.gltfLoader.setDRACOLoader(this.dracoLoader);
        }
        this.material = new THREE.PointsMaterial({ color: 0xff0000, size: 10 });
        this.droneGeometry = new THREE.Group();
        this.pointsGeometry = new THREE.Group();

        this.droneGeometry.name = "DroneGroup";
        //.graphics.scene.add(this.droneGeometry);
        this.pointsGeometry.name = "PointsGroup";
        //this.graphics.scene.add(this.pointsGeometry);
        //this.loadDrone();
    }


    public async createDroneInspections(droneImagePositionResult: any, fileList: File[]) {
        if (droneImagePositionResult) {
            if(this.pointsGeometry.parent === null){
                this.graphics.scene.add(this.pointsGeometry);
            }
            while (this.pointsGeometry.children.length > 0) {
                if (this.pointsGeometry.children[0] instanceof THREE.Mesh) {
                    this.pointsGeometry.children[0].geometry?.dispose();
                }
                this.pointsGeometry.remove(this.pointsGeometry.children[0]);
            }
            let index = 0;
            const offset = 0; // conferir
            let internsecPoint = null;
            for (const iterator of droneImagePositionResult) {
                const vertices = [];
                const normals = [];
                vertices.push(iterator.latitude)
                vertices.push(iterator.longitude)
                vertices.push(iterator.altitude + offset)

                normals.push(iterator.alpha)
                normals.push(iterator.beta)
                normals.push(iterator.gamma)

                const clone = this.droneGeometry.clone(true);
                clone.position.set(iterator.latitude, iterator.longitude, iterator.altitude + offset);
                this.pointsGeometry.add(clone);

                const raycaster = new THREE.Raycaster(new THREE.Vector3(iterator.latitude, iterator.longitude, iterator.altitude + offset)
                    , new THREE.Vector3(iterator.alpha, iterator.beta, iterator.gamma));

                const selectableElements = this.assetManager.asset.GetVisibleGroups();
                const intersects = raycaster.intersectObjects(selectableElements, true);
                if (!Util.isNullOrUndefined(intersects)) {
                    internsecPoint = intersects[0].point;
                    // await this.addDroneInspection((intersects[0].object as THREE.Mesh), fileList[index], iterator.AnomalyClassification.replace('"', '').replace('"', '').toLowerCase(), iterator.AnomalyConfidence);
                }
                const geometry = new THREE.BufferGeometry();
                geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
                geometry.setAttribute('normal', new THREE.Float32BufferAttribute(normals, 3));
                
                const points = new THREE.Points(geometry, this.material);
                //this.graphics.scene.add(points);
                const helper = new VertexNormalsHelper(points, 5, 0xff0000);
                this.drawNormalAsCylinder(new THREE.Vector3(vertices[0], vertices[1], vertices[2]), internsecPoint, new THREE.Vector3(normals[0], normals[1], normals[2]),
                0.03, 5, this.pointsGeometry, this.material);
                index++;
            }

            // this.graphics.scene.add(helper);
            // this.addCross(internsecPoint, 0.1, this.graphics.scene, new THREE.Vector3(normals[0], normals[1], normals[2]));
        }
    }

    private drawNormalAsCylinder(
        point: THREE.Vector3,
        internsecPoint: THREE.Vector3,
        normal: THREE.Vector3,
        thickness: number,
        length: number,
        scene: THREE.Group,
        material: THREE.Material
      ): void {
        if (normal.length() === 0) {
            console.warn('Normal vector has zero length. Skipping tube creation.');
            return;
        }

        const endpoint = new THREE.Vector3().addVectors(
            point,
            normal.clone().normalize().multiplyScalar(length)
        );

        const curve = new THREE.LineCurve3(point, endpoint);

        const geometry = new THREE.TubeGeometry(curve, 8, thickness, 16, true);

        const tube = new THREE.Mesh(geometry, material);

        scene.add(tube);
        let offset = 0.0551
        const crossPosition = new THREE.Vector3().addVectors(
            internsecPoint??new THREE.Vector3(),
            normal.clone().normalize().multiplyScalar(-offset)
          );

        this.addCross(crossPosition, 0.1, scene, normal);
    }

    private addCross(position: THREE.Vector3, size: number, scene: THREE.Group, normal: THREE.Vector3): void {
        const material = new THREE.LineBasicMaterial({ color: 0xff0000 });

        const halfSize = size / 2;
        const crossPoints = [
          new THREE.Vector3(-halfSize, 0, 0),
          new THREE.Vector3(halfSize, 0, 0),
          new THREE.Vector3(0, -halfSize, 0),
          new THREE.Vector3(0, halfSize, 0),
        ];
        const crossGroup = new THREE.Group();

        const horizontalGeometry = new THREE.BufferGeometry().setFromPoints([
            crossPoints[0],
            crossPoints[1],
        ]);
        const horizontalLine = new THREE.Line(horizontalGeometry, material);
        crossGroup.add(horizontalLine);

        const verticalGeometry = new THREE.BufferGeometry().setFromPoints([
            crossPoints[2],
            crossPoints[3],
        ]);
        const verticalLine = new THREE.Line(verticalGeometry, material);
        crossGroup.add(verticalLine);

        crossGroup.position.copy(position);

        const up = new THREE.Vector3(0, 0, 1); // Default orientation
        const quaternion = new THREE.Quaternion().setFromUnitVectors(up, normal.clone().normalize());
        crossGroup.applyQuaternion(quaternion);

        scene.add(crossGroup);
    }

    public async loadDrone() {
        const dronePath = 'https://phdc4dtest.blob.core.windows.net/phdsoft/cad/assets/2d9a19543f5e42b3a708841d164d3c77/geometry/g_20210702140212_2d9a19543f5e42b3a708841d164d3c77_gltf.gltf'

        if (!Util.isNullOrUndefined(dronePath)) {
            const gltfFile: any = await this.phdsoftCommonService.getFileArrayBuffer(
                dronePath, !window.navigator.onLine
            );

            await this.gltfLoader.loadOffline(
                gltfFile,
                (gltf) => {
                    for (const Object3D of gltf.scene.children) {
                        if (Object3D.type === 'Object3D') {
                            for (const _mesh of Object3D.children) {
                                if (_mesh.type === 'Mesh') {
                                    (_mesh as THREE.Mesh).geometry.scale(0.06, 0.06, 0.06);
                                    this.droneGeometry.add(_mesh);
                                    //return;
                                }
                            }
                        }
                    }
                },
                (xhr) => {
                    console.log('xhr', xhr);
                },
            );
            // this.updateProgress();
        }
    }

    private async addDroneInspection(target, file, classification, confidence) {
        this.assetManager.currentInspectionTypeId = '7188d6f6-afcd-4fea-a933-fa08f22cb2ae';
        let _target: WorkableElement = null

        for (const structureCollection of this.assetManager.asset.StructureCampaigns) {
            if (this.assetManager.currentSection?.Guid) {
                _target = structureCollection.getElementById(
                    this.assetManager.currentRegion.Guid,
                    this.assetManager.currentSection.Guid,
                    target.name,
                )
                if (_target) break
            } else {
                _target = structureCollection.getElementByIdOnly(
                    this.assetManager.currentRegion.Guid,
                    target.name,
                )
                if (_target) break
            }
        }

        const inspection = await this.assetManagerInspection.InsertNewDroneInspectionElement(_target, file, classification, confidence);

        // if (target.userData.Class === 'Inspection') {
        //     const _inspection = this.assetManager.currentInspectionCollection.Elements.find(x => x.design.name === target.name);
        //     var k: string = "0";
        //     for (let key in _inspection.checklist) {


        //         if (_inspection.checklist[key].Label.toLowerCase() == classification) {


        //             if (_inspection.checklist[key].Value == "NOK") {

        //                 _inspection.checklist[key].Comments = _inspection.checklist[key].Comments + String(confidence * 100) + '% ' + ';';
        //                 // for (const iterator of droneImagePositionResult) {

        //             } else {

        //                 _inspection.checklist[key].Value = "NOK";
        //                 _inspection.checklist[key].Comments = 'Classification Levels of confidence (in order): ' + String(confidence * 100) + '% ' + '; ';
        //             }


        //             k = key;


        //         }
        //         if (_inspection.checklist[key].Label.toLowerCase() == classification) {


        //             //_inspection.checklist[key].Attachments = file;
        //             //this.addDocument([file], 'CheckListId', (_inspection.checklist[0] as any).Id, _inspection.checklist[key]);
        //             _inspection.checklist[key].Value = "NOK";
        //             _inspection.checklist[key].Comments = 'Classification Level of confidence: ' + String(confidence);
        //             k = key;


        //         } else {

        //             _inspection.checklist[key].Value = "OK";
        //         }


        //         //}


        //     }



        //     this.addDocument([file], 'CheckListId', (_inspection.checklist[k] as any).Id, _inspection.checklist[k]);
        // }
        // else {
        //     let _otherInspection = new OtherInspection(
        //         true,
        //         target,
        //         target,
        //         null,
        //     );
        //     _otherInspection.type = 'OTHERINSPECTION'
        //     _otherInspection.saved = false;

        //     _otherInspection.regionId = target.userData.RegionId;

        //     _otherInspection.inspectionMethodId = this.assetManager.currentInspectionCollection.CollectionInfoModel.CurrentMethodId;
        //     _otherInspection.inspectionTypeId = this.assetManager.currentInspectionCollection.CollectionInfoModel.CurrentInspectionTypeId
        //     if (this.assetManager.functionalityMode === 'INSPECTIONINSERTION') {
        //         this.assetManager.currentInspectionCollection.addInspectionAlreadyInGroup(_otherInspection);
        //         this.collectionService.addElement(_otherInspection, this.assetManager.currentInspectionCollection.Date, true);
        //     }

        //     _otherInspection.design.material = _otherInspection.inspectionTypeId === '45fc0dce-e0b1-4688-8a55-967e712687fd' ?
        //         this.graphics.inspectionMaterial1 : this.graphics.inspectionMaterial;



        //     //await this.addDocument([file], 'CheckListId', (_otherInspection.checklist[0] as any).Id, _otherInspection.checklist[0]);
        //     var k: string = "0";
        //     for (let key in _otherInspection.checklist) {

        //         // for (const iterator of droneImagePositionResult) {


        //         if (_otherInspection.checklist[key].Label.toLowerCase() == classification) {


        //             //_otherInspection.checklist[key].Attachments = file;
        //             //await this.addDocument([file], 'CheckListId', (_otherInspection.checklist[0] as any).Id, _otherInspection.checklist[key]);
        //             _otherInspection.checklist[key].Value = "NOK";
        //             _otherInspection.checklist[key].Comments = 'Classification Levels of confidence (in order): ' + String(confidence * 100) + '% ' + '; ';
        //             k = key;

        //         } else {

        //             _otherInspection.checklist[key].Value = "OK";
        //         }


        //         //}


        //     }

        //     this.addDocument([file], 'CheckListId', (_otherInspection.checklist[k] as any).Id, _otherInspection.checklist[k]);

        // }


    }//cvi = "45fc0dce-e0b1-4688-8a55-967e712687fd"

    // async addDocument(
    //     fileList: File[],
    //     mediaProperty?: string,
    //     mediaValue?: any,
    //     checklist?: ChecklistItem
    // ): Promise<DocumentMediaModel[]> {

    //     // Get Current asset Id
    //     const _ASSET_ID: string = this.graphicsRender.assetId;

    //     const documentsObject: DocumentMediaModel = {
    //         AssetId: _ASSET_ID,
    //         Keywords: `CHECKLIST, ${mediaValue}`,
    //         DocumentType: null,
    //         CreatedById: _C4D_WEBTRANSFER?.DataInfo?.UserId
    //     };

    //     if (mediaProperty) {
    //         documentsObject[mediaProperty] = mediaValue;
    //     }

    //     // Set object on Transfer Data
    //     _C4D_WEBTRANSFER.Data = documentsObject;

    //     // Set AssetId info
    //     _C4D_WEBTRANSFER.DataInfo.AssetId = _ASSET_ID;
    //     let _RESPONSE_MEDIA_LIST: DocumentMediaModel[];

    //     try {
    //         documentsObject.BlobPath = null;
    //         // call api to save data and file
    //         _RESPONSE_MEDIA_LIST = await this.phdsoftCommonService.postFileList<DocumentMediaModel[]>(
    //             environment.API_MEDIA,
    //             'Media/PostMediaList',
    //             _C4D_WEBTRANSFER,
    //             fileList,
    //         );

    //         if (_RESPONSE_MEDIA_LIST) {
    //             console.log('_RESPONSE_MEDIA_LIST', _RESPONSE_MEDIA_LIST);
    //         }
    //     } catch (error) {
    //         ///
    //     }
    //     const mediaDocumentIds = _RESPONSE_MEDIA_LIST.map(d => d.id);
    //     checklist.Attachments.push(mediaDocumentIds[0]);

    //     return _RESPONSE_MEDIA_LIST;
    // }

    private createElementsViewModel(
        targetElement: WorkableElement,
        collection: InspectionCampaign,
        scope: string,
    ): ElementResultInfo {
        const element: ElementResultInfo = {
            Element: null,
            IsPlanned: true,
            InsertedRegionId: targetElement.regionId,
            id: uuid() as string,
            TargetGeometryId: targetElement.Guid,
            TargetGeometryTypeId: targetElement.TypeId,
            InspectionMethodId: collection.CollectionInfoModel.CurrentMethodId,
            SectionId: targetElement.SectionId,
            Scope: scope,
        }
        return element
    }
}
